module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Willkommen_BG.0f89dc0d.jpg";